import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, FileQuestion } from 'lucide-react';

/**
 * Fallback UI for unknown routes (404).
 */
export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-[60vh] flex items-center justify-center p-8"
      dir="rtl"
    >
      <div className="max-w-lg w-full text-center rounded-2xl p-10 border bg-white/5 border-white/10 backdrop-blur-xl">
        <FileQuestion className="mx-auto mb-4 text-emerald-400" size={48} strokeWidth={1.5} aria-hidden />
        <h1 className="text-2xl font-bold text-white mb-2">{t('common.page_not_found_title')}</h1>
        <p className="text-white/70 mb-6">{t('common.page_not_found_description')}</p>
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-r from-emerald-500 to-emerald-700 text-white font-semibold"
        >
          <Home size={16} aria-hidden />
          {t('common.page_not_found_home')}
        </Link>
      </div>
    </div>
  );
}
